import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import Collapse from "react-bootstrap/Collapse";
import { IMAGES } from "../../../constant/theme";
import {
  getTenantUser,
  getUserByTenantId,
  mapUserWithTenant,
  removeUserTenatMappingByid,
} from "../../../../services/TenantsService";
import { Button, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const AboutTenant = () => {
  const location = useLocation();

  const user = location.state?.user || null;
  const [open2, setOpen2] = useState(true);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [userTenant, setUserTenant] = useState(null);
  const [userSearch, setUserSearch] = useState("");
  const [userPage, setUserPage] = useState(0);
  const [userSize, setUserSize] = useState(10);
  const [userTotalPages, setUserTotalPages] = useState(0);
  const [userTotalElements, setUserTotalElements] = useState(0);
  const [userCurrentStart, setUserCurrentStart] = useState(0);
  const [userLoading, setUserLoading] = useState(false);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const pageSize = 20;

  async function fetchUserTenant(currentPage = userPage, currentSize = userSize, querySearch = userSearch) {
    if (!user?.id) return;
    try {
      setUserLoading(true);
      const searchParam = querySearch?.trim() ? querySearch.trim() : undefined;
      const res = await getUserByTenantId(user?.id, currentPage, currentSize, searchParam, true);
      if (res) {
        console.log("User Tenants:", res);
        setUserTenant(res.content || []);
        setUserTotalElements(res?.totalElements || 0);
        setUserTotalPages(res?.totalPages || 0);
        setUserCurrentStart(res?.number || 0);
      }
    } catch (error) {
      console.error("Error fetching user tenant:", error);
    } finally {
      setUserLoading(false);
    }
  }

  useEffect(() => {
    if (!user?.id) return;
    const timer = setTimeout(() => {
      fetchUserTenant(userPage, userSize, userSearch);
    }, 400);

    return () => clearTimeout(timer);
  }, [user?.id, userPage, userSize, userSearch]);

  // const loadTenants = async (pageToLoad = 0) => {
  //   if (isLoading || !hasMore) return;
  //   try {
  //     setIsLoading(true);
  //     const data = await getTenantUser(pageToLoad, pageSize);
  //     if (data) {
  //       const existingTenantIds =
  //         (userTenant.length > 0 && userTenant?.map((t) => t?.tenant?.id)) ||
  //         [];
  //       const filterTenantData = data?.content?.filter((t) => {
  //         return !existingTenantIds.includes(t?.id);
  //       });
  //       console.log("filterTenantData sk", filterTenantData);
  //       const newOptions = filterTenantData?.map((user) => ({
  //         label: user?.name,
  //         value: user?.id,
  //       }));

  //       setTenantOptions((prev) => [...prev, ...newOptions]);

  //       // If backend sends info about last page:
  //       if (data.last === true || data.content.length < pageSize) {
  //         setHasMore(false);
  //       } else {
  //         setPage(pageToLoad + 1);
  //       }
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const loadTenants = async (pageToLoad = 0) => {
    if (isLoading || !hasMore) return;

    try {
      setIsLoading(true);

      const data = await getTenantUser(pageToLoad, pageSize);

      if (data) {
        console.log("Tenant Data:", data);
        const existingTenantIds = userTenant?.map((t) => t?.id) || [];

        const filterTenantData = data?.content?.filter(
          (t) => !existingTenantIds.includes(t?.id),
        );

        const newOptions = filterTenantData?.map((tenant) => ({
          label: `${tenant?.name} - ${tenant?.email}`,
          value: tenant?.id,
        }));

        setTenantOptions((prev) => [...prev, ...newOptions]);

        if (data.last === true || data.content.length < pageSize) {
          setHasMore(false);
        } else {
          setPage((prev) => prev + 1);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTenants();
  }, []);

  async function handleAddTenant() {
    var payload = {
      tenantId: user?.id,
      userId: selectedTenant?.value,
    };
    const data = await mapUserWithTenant(payload);
    if (data) {
      fetchUserTenant(userPage, userSize, userSearch);
      setSelectedTenant(null);
    } else {
      console.error("Failed to add tenant");
    }
  }

  const handleStatusChange = async (targetUser, newStatus) => {
    const isGrant = newStatus === "ACTIVE";
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${isGrant ? "Grant" : "Revoke"} access for ${targetUser?.name || "this user"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isGrant ? "#3085d6" : "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: `Yes, ${isGrant ? "Grant" : "Revoke"} Access!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          userId: targetUser?.id,
          tenantId: user?.id,
          status: newStatus,
        };
        try {
          const res = await removeUserTenatMappingByid(payload);
          if (res) {
            Swal.fire(
              "Updated!",
              `Access has been ${isGrant ? "Granted" : "Revoked"} successfully.`,
              "success",
            );
            fetchUserTenant(userPage, userSize, userSearch);
          }
        } catch (error) {
          console.error("Error changing user status:", error);
          Swal.fire(
            "Error!",
            error?.response?.data?.message || "Failed to update status",
            "error",
          );
        }
      }
    });
  };

  return (
    <>
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">About Academy</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/super-admin/all-tenants">Academies</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link
              onClick={(e) => e.preventDefault()}
              to="#"
              style={{
                pointerEvents: "none",
                color: "inherit",
                color: "#6F77F8",
              }}
            >
              About Academy
            </Link>
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-xl-3 col-lg-4">
          <div className="clearfix">
            <div className="card card-bx profile-card author-profile mb-3">
              <div className="card-body">
                <div className="p-5">
                  <div className="author-profile">
                    <div className="author-media">
                      <img src={IMAGES.tab1} alt="" />
                      <div
                        className="upload-link"
                        title=""
                        data-toggle="tooltip"
                        data-placement="right"
                        data-original-title="update"
                      >
                        <input type="file" className="update-flie" />
                        <i className="fa fa-camera"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-8">
          <div className="card profile-card card-bx ">
            <div className="card-header">
              <h6 className="card-title">Academy Details</h6>
            </div>
            <form className="profile-form">
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.name || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Email address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.email || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="number"
                      className="form-control"
                      value={user?.phone || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Landline</label>
                    <input
                      type="number"
                      className="form-control"
                      value={user?.landLine || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Contact Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.contactName || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Status Comment</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.statusComment || ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              {/* <div className="card-footer align-items-center d-flex">
                <Link to={"#"} className="btn-link float-end ms-auto">
                  Reset your password?
                </Link>
              </div> */}
            </form>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="d-flex justify-content-end gap-2">
            <div className="mb-3 col-3">
              <Select
                value={selectedTenant}
                onChange={setSelectedTenant}
                options={tenantOptions}
                placeholder="Select user"
                onMenuScrollToBottom={() => {
                  if (hasMore && !isLoading) {
                    loadTenants(page); // load next page
                  }
                }}
                isLoading={isLoading}
              />
            </div>
            <div className="mb-3 ">
              <Button
                className="btn btn-primary btn-m"
                disabled={!selectedTenant}
                onClick={handleAddTenant}
              >
                Add User
              </Button>
            </div>
          </div>

          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen2(!open2)}>
              <div className="cpa">
                <i className="fa-solid fa-file-lines me-2" />
                Users List
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body py-3">
                  <div className="table-responsive order-list-table">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {userSize}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setUserSize(val);
                                      setUserPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder="Search user..."
                              value={userSearch}
                              onChange={(e) => {
                                setUserSearch(e.target.value);
                                setUserPage(0);
                              }}
                            />
                          </label>
                        </div>
                      </div>
                      <table className="table table-responsive-lg  table-condensed flip-content">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Landline</th>
                            <th>Role</th>
                            <th>Permission</th>
                            <th>Status</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userLoading && (
                            <tr>
                              <td colSpan={9} className="text-center">
                                Loading...
                              </td>
                            </tr>
                          )}
                          {!userLoading && userTenant?.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center">
                                No data found
                              </td>
                            </tr>
                          )}
                          {!userLoading &&
                            userTenant?.map((item, ind) => (
                            <tr key={ind}>
                              <td>{userPage * userSize + ind + 1}</td>
                              <td>{item?.name}</td>
                              <td>{item?.email}</td>
                              <td>{item?.phone}</td>
                              <td>{item?.landLine}</td>
                              <td>
                                {item?.defaultTenant?.admin ? "Admin" : "User"}
                              </td>
                              <td>
                                <span
                                  className={`badge light ${item?.defaultTenant?.status === "INACTIVE"
                                    ? "badge-danger"
                                    : "badge-success"
                                    }`}
                                >
                                  {item?.defaultTenant?.status === "INACTIVE" ? "Removed" : "Granted"}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge light ${item?.status === "INACTIVE"
                                    ? "badge-danger"
                                    : "badge-success"
                                    }`}
                                >
                                  {item?.status || "ACTIVE"}
                                </span>
                              </td>
                              <td className="text-end">
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="success"
                                    className="light sharp i-false"
                                  >
                                    {svg1}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu
                                    renderOnMount
                                    popperConfig={{
                                      strategy: "fixed",
                                      modifiers: [
                                        {
                                          name: "flip",
                                          options: {
                                            fallbackPlacements: [
                                              "bottom-end",
                                              "top-end",
                                            ],
                                          },
                                        },
                                        {
                                          name: "preventOverflow",
                                          options: {
                                            boundary: "viewport",
                                          },
                                        },
                                      ],
                                    }}
                                  >
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleStatusChange(item, "ACTIVE")
                                      }
                                      className={
                                        item?.defaultTenant?.status === "ACTIVE" ||
                                          !item?.defaultTenant?.status
                                          ? "text-success fw-bold"
                                          : ""
                                      }
                                    >
                                      Grant
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleStatusChange(item, "INACTIVE")
                                      }
                                      className={
                                        item?.defaultTenant?.status === "INACTIVE"
                                          ? "text-danger fw-bold"
                                          : ""
                                      }
                                    >
                                      Remove
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {userTotalPages > 0 ? userCurrentStart + 1 : 0} of {userTotalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${
                              userPage === 0 ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (userPage > 0) setUserPage(userPage - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${
                              userPage + 1 >= userTotalPages ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (userPage + 1 < userTotalPages)
                                setUserPage(userPage + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};
export default AboutTenant;
